/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';

// @ts-expect-error
import CommentBus from 'notebook/protocols/viewer/CommentBus';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

interface Props {
  canCancel: boolean;
  linkableID?: number | string;
  linkType: string;
  onDescription: boolean;
  onCancel?: (...args: Array<any>) => any;
  onSubmit?: (...args: Array<any>) => any;
  commentBus: CommentBus;
  shouldFocus: boolean;
}

export default class CommentForm extends React.Component<Props> {
  static defaultProps = {canCancel: false};

  _isMounted: any;
  commentInputRef = React.createRef<HTMLTextAreaElement>();
  commentButtonRef = React.createRef<HTMLButtonElement>();

  toggleFormDisabled = (): void => {
    if (this._isMounted) {
      const disabled = $(ReactDOM.findDOMNode(this.commentInputRef.current)!).val().length === 0;
      $(ReactDOM.findDOMNode(this.commentButtonRef.current)!).toggleClass('is-disabled', disabled);
    }
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  createComment = () => {
    const $input = $(ReactDOM.findDOMNode(this.commentInputRef.current)!);
    const comment = $input.val();
    $(ReactDOM.findDOMNode(this.commentButtonRef.current)!).addClass('is-disabled');
    return this.props.commentBus
      .createComment({
        linkableID: this.props.linkableID,
        linkType: this.props.linkType,
        onDescription: this.props.onDescription,
        text: comment,
      })
      .done(() => {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'val' does not exist on type 'JQueryStati... Remove this comment to see the full error message
        $input.val(null).trigger('autosize.resize');
        return typeof this.props.onSubmit === 'function' ? this.props.onSubmit() : undefined;
      })
      .always(this.toggleFormDisabled);
  };

  componentDidMount(): void {
    this._isMounted = true;
    const $node = $(ReactDOM.findDOMNode(this.commentInputRef.current)!);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'autosize' does not exist on type 'JQuery... Remove this comment to see the full error message
    $node.autosize();
    if (this.props.shouldFocus) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'focus' does not exist on type 'JQuerySta... Remove this comment to see the full error message
      return $node.focus();
    }
  }

  componentWillUnmount(): void {
    this._isMounted = false;
  }

  render(): JSX.Element {
    return (
      <form>
        <div className="cm-creator">
          <div className="user-img">
            <img src={this.props.commentBus.user.avatar_url} width={32} height={32} />
          </div>
          <div className="cm-wrapper">
            <textarea
              placeholder="Leave a comment"
              ref={this.commentInputRef}
              onInput={this.toggleFormDisabled}
            />
            <div className="cm-buttons">
              <button
                type="button"
                ref={this.commentButtonRef}
                className="button button--small button--primary is-disabled"
                onClick={this.createComment}
              >
                Comment
              </button>
              {this.props.canCancel ? (
                <Button
                  buttonStyle={ButtonStyle.TERTIARY_GRAY}
                  size={ButtonSize.SMALL}
                  onClick={this.props.onCancel}
                  text="Cancel"
                />
              ) : undefined}
            </div>
          </div>
        </div>
      </form>
    );
  }
}
